var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBilling(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "#6D7781",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.911 16.5H1.67539C0.753927 16.5 0 15.7461 0 14.8246V2.17539C0 1.25393 0.753927 0.5 1.67539 0.5H14.911C15.8325 0.5 16.5864 1.25393 16.5864 2.17539V14.8246C16.5864 15.7461 15.8325 16.5 14.911 16.5ZM1.67539 1.3377C1.25654 1.3377 0.837696 1.75654 0.837696 2.17539V14.8246C0.837696 15.3272 1.25654 15.6623 1.67539 15.6623H14.911C15.4136 15.6623 15.7487 15.2435 15.7487 14.8246V2.17539C15.7487 1.67277 15.3298 1.3377 14.911 1.3377H1.67539Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1675 2.84555H0.418854V3.68325H16.1675V2.84555Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0681 14.5733H3.43455C3.18324 14.5733 3.0157 14.4058 3.0157 14.1545C3.0157 13.9031 3.18324 13.7356 3.43455 13.7356H13.0681C13.3194 13.7356 13.4869 13.9031 13.4869 14.1545C13.4869 14.4058 13.3194 14.5733 13.0681 14.5733Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.979 12.6466C11.7277 12.6466 11.5602 12.4791 11.5602 12.2277V5.35864C11.5602 5.10733 11.7277 4.93979 11.979 4.93979C12.2304 4.93979 12.3979 5.10733 12.3979 5.35864V12.2277C12.3979 12.4791 12.2304 12.6466 11.979 12.6466Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.29318 12.6466C8.04187 12.6466 7.87433 12.4791 7.87433 12.2277V7.03403C7.87433 6.78272 8.04187 6.61518 8.29318 6.61518C8.54449 6.61518 8.71203 6.78272 8.71203 7.03403V12.2277C8.71203 12.4791 8.54449 12.6466 8.29318 12.6466Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.60732 12.6466C4.35602 12.6466 4.18848 12.4791 4.18848 12.2277V8.70942C4.18848 8.45811 4.35602 8.29057 4.60732 8.29057C4.85863 8.29057 5.02617 8.45811 5.02617 8.70942V12.2277C5.02617 12.4791 4.77486 12.6466 4.60732 12.6466Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 16.5864,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBilling);
export default __webpack_public_path__ + "static/media/billing.1633230e.svg";
export { ForwardRef as ReactComponent };